export type MetaPayload = Record<string, unknown>;

type MetaTrackMode = "track" | "trackCustom";
type FbqFunction = (mode: MetaTrackMode, eventName: string, payload?: MetaPayload) => void;

declare global {
  interface Window {
    fbq?: FbqFunction;
  }
}

const getFbq = (): FbqFunction | null => {
  if (!process.client) return null;
  return typeof window.fbq === "function" ? window.fbq : null;
};

const emitMetaEvent = (
  mode: MetaTrackMode,
  eventName: string,
  payload?: MetaPayload,
  debug = false
): boolean => {
  const fbq = getFbq();
  if (!fbq) return false;

  try {
    if (payload && Object.keys(payload).length) {
      fbq(mode, eventName, payload);
    } else {
      fbq(mode, eventName);
    }

    if (debug) {
      // console.log(`[Meta Pixel] ${mode}:${eventName}`, payload ?? {});
    }
    return true;
  } catch {
    return false;
  }
};

export const trackMetaStandardEvent = (
  eventName: string,
  payload?: MetaPayload,
  debug = false
): boolean => emitMetaEvent("track", eventName, payload, debug);

export const trackMetaCustomEvent = (
  eventName: string,
  payload?: MetaPayload,
  debug = false
): boolean => emitMetaEvent("trackCustom", eventName, payload, debug);

